import { useState } from "react";

const FaqItem = ({ question, answer, isOpen, onToggle }) => (
  <div className="overflow-hidden rounded-xl border border-slate-200/80 bg-white transition-shadow hover:shadow-soft">
    <button
      type="button"
      onClick={onToggle}
      aria-expanded={isOpen}
      className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
    >
      <span className="text-sm sm:text-base font-medium text-slate-900">
        {question}
      </span>
      <span
        className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-lg border border-slate-200 text-slate-500 transition-transform duration-200 ${
          isOpen ? "rotate-180 bg-slate-50" : "bg-white"
        }`}
      >
        <svg className="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
          <path
            fillRule="evenodd"
            d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.94a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z"
            clipRule="evenodd"
          />
        </svg>
      </span>
    </button>
    <div
      className={`grid transition-all duration-200 ease-out ${
        isOpen ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
      }`}
    >
      <div className="overflow-hidden">
        <p className="px-5 pb-4 text-sm leading-relaxed text-slate-600">
          {answer}
        </p>
      </div>
    </div>
  </div>
);

const FaqAccordion = ({ items }) => {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <div className="space-y-3">
      {items.map((item, index) => (
        <FaqItem
          key={item.q}
          question={item.q}
          answer={item.a}
          isOpen={openIndex === index}
          onToggle={() => setOpenIndex(openIndex === index ? -1 : index)}
        />
      ))}
    </div>
  );
};

export default FaqAccordion;
